import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			fontWeight: 500,
			padding: '1rem 1.5rem 0.75rem 1.5rem'
		}
	})
);

export interface IMessageProps {
	message: string;
}

const Message: React.FunctionComponent<IMessageProps> = props => {
	const classes = useStyles();
	return <div className={classes.root}>{props.message}</div>;
};

export default Message;
